module.exports = __webpack_public_path__ + "img/hr-branch-particle-shadow-10.5fbea9b9.png";